import { useEffect, useState } from "react";
import { MIN_PANEL_DIMENSION_MM, parseLengthInputMm } from "@plaatplan/core";
import { useLocale } from "../i18n/useLocale";

/**
 * Controlled length field stored as mm in project state.
 * Metric: number input in mm. Imperial: text input with fractions/feet.
 */
export function LengthInput({
  valueMm,
  onChangeMm,
  minMm = MIN_PANEL_DIMENSION_MM,
  className,
  "aria-label": ariaLabel,
  step,
  compact = false,
  list,
  snapMmValues,
}) {
  const { display } = useLocale();
  const [draft, setDraft] = useState("");
  const [focused, setFocused] = useState(false);
  const hasValue = valueMm !== "" && valueMm !== null && valueMm !== undefined;
  const numericValue = hasValue ? Number(valueMm) || 0 : 0;

  useEffect(() => {
    if (!focused) {
      setDraft(hasValue ? display.formatLengthInput(numericValue) : "");
    }
  }, [hasValue, numericValue, focused, display]);

  if (display.unitSystem === "metric") {
    return (
      <input
        className={className}
        type="number"
        min={minMm}
        step={step ?? (compact ? "0.1" : "1")}
        value={hasValue ? numericValue : ""}
        aria-label={ariaLabel}
        list={list}
        onChange={(event) => onChangeMm(event.target.value)}
      />
    );
  }

  const commit = (raw = draft) => {
    const parsed = parseLengthInputMm(raw, {
      unitSystem: display.unitSystem,
      minMm,
      snapMmValues,
    });
    if (parsed !== null) {
      onChangeMm(String(parsed));
      setDraft(display.formatLengthInput(parsed));
      return true;
    }
    setDraft(hasValue ? display.formatLengthInput(numericValue) : "");
    return false;
  };

  return (
    <input
      className={className}
      type="text"
      inputMode="decimal"
      value={draft}
      aria-label={ariaLabel}
      list={list}
      onFocus={() => setFocused(true)}
      onBlur={() => {
        commit();
        setFocused(false);
      }}
      onChange={(event) => setDraft(event.target.value)}
      onKeyDown={(event) => {
        if (event.key === "Enter") {
          event.preventDefault();
          if (commit()) {
            event.currentTarget.blur();
          }
        }
      }}
    />
  );
}
